import { vec3 } from 'gl-matrix';

const _u = vec3.create();
const _v = vec3.create();

export class Plane {
  public readonly normal = vec3.create();
  private constant = 0;

  constructor(public name: string) {}

  /** Recompute normal and constant from three coplanar points. */
  public updateFromPoints(a: vec3 | number[], b: vec3 | number[], c: vec3 | number[]): void {
    vec3.subtract(_u, b, a);
    vec3.subtract(_v, c, a);
    vec3.cross(this.normal, _u, _v);
    vec3.normalize(this.normal, this.normal);
    this.constant = -vec3.dot(this.normal, a);
  }

  public determineDistance(point: vec3 | number[]): number {
    return this.constant + vec3.dot(this.normal, point);
  }
}
